module.exports = __webpack_public_path__ + "static/media/success.a194cd07.mp3";